(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/national.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/national.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.National = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.national(data);
    }
  });
})(Backbone, _, svs);

 })(window);